var _clipPath, _rect, _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V150H700V300H600zM600,0H300V350H0V300z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#00247d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 600,300M600,0 0,300",
    stroke: "#fff",
    strokeWidth: 60
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 600,300M600,0 0,300",
    stroke: "#cf142b",
    strokeWidth: 40,
    clipPath: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300,0V350M0,150H700",
    stroke: "#fff",
    strokeWidth: 100
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300,0V350M0,150H700",
    stroke: "#cf142b",
    strokeWidth: 60
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0,300H600V0H800V400H0z",
    fill: "#00247d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#cc3",
    d: "m780.583,154.039c0,148.827,11.8732,201.675,52.6064,242.479,40.7332,40.8042,56.1659,47.2313,67.5231,53.4827,13.1015-7.21148,28.1971-15.1341,65.1152-52.0521,36.513-36.515,54.173-89.15,54.173-246.452-26.559,11.3712-39.7859,15.1175-63.0119,15.0513-17.202,1.68548-43.7399-9.33789-59.6086-16.5484-10.371,6.60246-25.4152,14.4763-52.4514,15.3604-31.2252,1.30952-41.1191-3.73522-64.3451-11.3217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m787.775,163.438c0,46.0434-2.72184,108.794,7.00639,145.1,9.77001,36.4622,12.0129,41.8034,19.3596,54.5282l171.206-1.27105c10.576-18.3181,11.1098-29.6647,18.9526-58.9348,7.8148-29.1649,9.7886-94.177,10.0167-142.6-17.216,8.72445-39.7613,14.9075-61.6436,12.1948-17.5423-1.2754-33.7513-5.09258-52.6268-15.2637-16.374,9.35261-22.0822,13.6217-49.1184,14.7138-21.0507,0.98975-38.1018,2.61503-63.1522-8.46789z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m814.51,362.056c12.1849,24.4477,69.6325,71.3032,86.433,81.0029,19.168-11.0667,69.8476-57.368,83.9727-81.0029h-170.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "m904.221,231.606c5.41355,12.1396,22.7699,25.5448,27.5414,32.1145-6.07314,6.56934-7.28706,5.85387-6.49064,18.0587,10.5604-10.534,10.7499-11.6322,17.5423-10.0346,14.8794,14.1555,2.66292,44.5571-9.63422,51.1666-12.2936,7.05101-10.0622-0.24417-28.4886,8.59299,8.44836,6.88711,18.237-1.01015,26.2362,1.10047,4.34697,4.91697-2.06648,13.8779,1.31216,22.317,7.06953-0.6489,6.22049-14.2559,7.86595-19.1896,5.16445-18.0757,36.2143-30.6826,37.7931-47.2631,6.54677-2.93012,13.09-0.9165,21.0507,3.34487-3.96455-15.5336-17.0792-15.3664-20.5946-20.2178-8.36767-12.1907-15.7845-26.0981-33.6566-29.7059-13.5672-2.73878-12.5532,0.82385-21.2472-4.83-5.41355-4.01853-21.8612-11.6181-19.2298-5.45416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "m860.839,283.106c8.72935-10.2344,13.0534-31.1272,16.9171-38.2184,8.92956,2.05041,8.83312,3.40792,19.7799-2.96497-14.7027-3.98084-15.8096-3.62755-17.5012-10.0994,6.17695-19.1553,40.0786-23.0599,51.953-15.7817,12.2822,7.06894,4.4742,8.596,21.2779,20.0001,2.44044-10.3389-9.45634-14.9009-11.2359-22.6298,2.52932-5.96126,13.8358-4.74122,20.084-11.5316-3.90439-5.6561-16.127,1.41619-21.4712,2.33396-19.1762,4.09085-45.373-16.1931-61.4875-9.77821-5.77578-4.14976-6.96507-10.606-6.73193-19.3072-12.5539,10.5985-6.27225,21.5753-9.12921,26.805-7.39678,12.7485-16.8297,25.4974-11.8265,42.248,3.79803,12.7158,6.62838,10.1968,5.44639,20.1666-1.19785,6.44061-0.56211,23.8553,3.92513,18.7577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "m931.763,290.302c-13.7027-1.82835-34.6943,5.45107-43.0585,5.96673-2.77851-8.34642-1.51002-8.96995-12.8934-14.605,4.03197,14.0554,4.9217,14.7758-0.0129,19.5038-20.3904,4.86884-41.4321-20.7724-41.0411-34.2257-0.008-13.6779,5.40195-8.09713,6.94685-27.7067-10.5433,3.35691-8.48447,15.4235-14.502,20.8735-6.65962,1.01994-11.4131-8.83635-20.7407-10.4218-3.05765,6.11145,9.61345,12.4257,13.2018,16.3114,13.5917,13.53,8.93457,45.397,23.0288,55.2268-0.7374,6.85915-5.91783,11.1692-13.8492,15.48,16.0079,4.76053,22.612-6.04289,28.7845-6.41709,15.2702-0.5594,31.594,0.5423,44.0424-12.2046,9.45-9.67656,5.72467-10.6828,15.2857-14.8756,6.40117-2.35427,21.7049-11.8813,14.8078-12.9056z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 266.239,
    cy: 122.104,
    r: 0.806,
    transform: "matrix(3.5084546,0,0,3.3448778,6.3307176,-163.01097)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 266.239,
    cy: 122.104,
    r: 0.806,
    transform: "matrix(-1.6389991,-2.9574373,3.1020668,-1.5625831,914.32327,1224.3275)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 266.239,
    cy: 122.104,
    r: 0.806,
    transform: "matrix(-1.8069804,2.8671155,-3.007328,-1.7227325,1749.0027,-240.21318)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.667cd16b5d6f52954bafffd4b71c0c3b.svg";
export { ForwardRef as ReactComponent };